import type { OnInit, OnDestroy } from '@angular/core';
import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import type { Subscription } from 'rxjs';

import type { ScreenFlags } from '../../models/screen-flags';
import { LanguageService } from '../../services/language.service';
import { ResponsiveDetectionService } from '../../services/responsive-detection.service';
import { ThemeService } from '../../services/theme.service';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-user-preferences',
  imports: [SharedModule],
  templateUrl: './user-preferences.component.html',
  styleUrl: './user-preferences.component.scss',
})
export class UserPreferencesComponent implements OnInit, OnDestroy {
  languageService = inject(LanguageService);
  themeService = inject(ThemeService);
  router = inject(Router);
  responsiveDetectionService = inject(ResponsiveDetectionService);

  screenFlags: ScreenFlags = {
    isMobile: false,
    isTablet: false,
    isLaptop: false,
    isDesktop: false,
  };

  currentLang = 'en';
  isDarkMode = true;
  @Input() hasLanguage = false;
  @Input() hasThemes = false;
  private langSubscription!: Subscription;
  private themeSubscription!: Subscription;

  ngOnInit(): void {
    this.langSubscription = this.languageService.getCurrentLang$().subscribe((lang) => {
      this.currentLang = lang;
    });

    this.themeSubscription = this.themeService.theme$.subscribe((theme) => {
      this.isDarkMode = theme === 'dark';
    });

    this.responsiveDetectionService.screenFlags$.subscribe((flags) => {
      this.screenFlags = flags;
    });
  }

  toggleLanguage(): void {
    this.languageService.toggleLanguage();
  }

  toggleThemeMode(): void {
    this.themeService.toggleTheme();
  }

  isAuth(): boolean {
    const ALLOWED_WHITE_COLORS: Record<string, unknown> = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '/auth/onboarding': true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '/auth/login': true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '/auth/forgot-password': true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '/auth/otp': true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '/auth/reset-password': true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      '/auth/signup': true,
    };

    if (this.screenFlags.isMobile && this.router.url === '/auth/onboarding') {
      return true;
    } else if (!this.screenFlags.isMobile && ALLOWED_WHITE_COLORS[this.router.url]) {
      return true;
    }

    return false;
  }

  ngOnDestroy(): void {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }

    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }
}
